import { useSelectedVideo } from '.';
import { useVideoPlayback } from './useVideoPlayback';

export const usePlayChannelText = (): string | undefined => {
  const { selectedVideo } = useSelectedVideo();
  const videoPlayback = useVideoPlayback(selectedVideo);
  return videoPlayback?.playVideoText;
};
